export default "__VITE_ASSET__DEtwvvD6__";